// Real Google reviews from Powerz Auto Electrical's GBP.
// `featured: true` = show on homepage testimonials section.
// Featured set is curated for MAXIMUM SEO IMPACT: each review covers a different
// high-value service category, mentions specific vehicles or brands by name,
// and ideally mentions "Powerz Auto Electrical" or "Zac" to reinforce entity match.
//
// `service` tags are deliberately aligned with our Services + Shop categories
// (Auto Electrical, 4WD Accessories, Towing Electrics, Auto Air Conditioning,
// Dual Battery, Solar, Lithium, Driving Lights, UHF, Diagnostics, etc.)
// so the /reviews filter UI reinforces the same keyword ecosystem the rest of
// the site is targeting.

export const REVIEWS = [
  // ───── FEATURED (homepage) — curated for service/keyword diversity ─────
  {
    name: "Aidan Batterham",
    service: "Diagnostics",
    featured: true,
    quote:
      "Absolutely stoked with the work from Powerz Auto Electrical. Zac seriously knows his stuff — you can tell straight away he actually understands what's going on and explains it properly. Had a few issues that weren't straightforward, and instead of just throwing parts at it, Zac took the time to properly diagnose everything. He put together a clear plan to get the car back to where it should be, which gave me a lot of confidence. Communication was spot on the whole way through — no surprises, just honest advice and quality workmanship. It's hard to find someone you can genuinely trust with your car, but Zac is definitely one of the good ones. Couldn't recommend Powerz Auto Electrical enough.",
  },
  {
    name: "Christopher Bennett",
    service: "Dual Battery",
    featured: true,
    quote:
      "Very prompt, fair pricing, and excellent workmanship. Nothing was too much trouble. Extremely happy with the dual battery setup.",
  },
  {
    name: "George Hajduk",
    service: "Towing Electrics",
    featured: true,
    quote:
      "Excellent work installing a full towing setup on my Pajero Sport. Professional, fair pricing and great service. Highly recommend.",
  },
  {
    name: "Steve Wallin",
    service: "Auto Air Conditioning",
    featured: true,
    quote:
      "Needed urgent AC work on my LandCruiser. Zac got me in quickly and fixed it. Outstanding service.",
  },
  {
    name: "Caleb Sinn",
    service: "Solar",
    featured: true,
    quote:
      "Professional, responsive, and very knowledgeable. Solar setup has been perfect.",
  },
  {
    name: "Riley",
    service: "UHF",
    featured: true,
    quote:
      "Zac installed a UHF in my Hilux and did a few extras. Super clean work, quick, and reasonably priced. Highly recommend.",
  },

  // ───── REMAINING (only on /reviews) ─────
  {
    name: "Jasmine Gray",
    service: "Auto Electrical",
    quote:
      "I brought my car in to have my automatic mirrors looked at for over rotation and honestly couldn't be happier with the experience. Zac was absolutely fantastic from start to finish. He worked in with my schedule, took his time explaining what was going on, and never made me feel like my questions were a bother. He was reassuring, well spoken, and just an all round great bloke. Will 100% be back and wouldn't hesitate to recommend Powerz Auto Electrical to anyone.",
  },
  {
    name: "Katherine Wood Fine Art",
    service: "European / Diagnostics",
    quote:
      "Took my VW in with multiple issues. Zac diagnosed everything and, when a specialist was needed, he organised it himself and didn't charge me. Made a client for life.",
  },
  {
    name: "Manda Richens",
    service: "Towing Electrics",
    quote:
      "Tow Pro install was super tidy and works perfectly. Professional and efficient.",
  },
  {
    name: "Colin Lowe",
    service: "Caravan / Towing Electrics",
    quote:
      "Highly recommend Zac. He installed caravan charging wiring in a timely manner and explained everything clearly. Legend.",
  },
  {
    name: "Kai Deighton",
    service: "Driving Lights",
    quote:
      "Fitted spotlights and fixed headlights on my Hilux. Everything works perfectly. Very trustworthy and knowledgeable.",
  },
  {
    name: "Fraser Henshall",
    service: "Driving Lights",
    quote: "Installed a full interior lighting package. Quick turnaround and great work.",
  },
  {
    name: "Maddie",
    service: "Auto Air Conditioning",
    quote:
      "Great service. Zac was easy to deal with and explained everything clearly. Aircon is icy cold again.",
  },
  {
    name: "Charlotte",
    service: "Auto Air Conditioning",
    quote: "Diagnosed and fixed an AC issue others couldn't. Honest and efficient.",
  },
  {
    name: "Tom Mitchell",
    service: "Project Van Build",
    quote:
      "Outstanding work on our project van. Attention to detail and professionalism were second to none.",
  },
  {
    name: "Luke Maurice",
    service: "Van Wiring",
    quote:
      "I needed a bunch of work done on the wiring in my van. Zac sorted everything out cleanly at a fair price in time for my road trip. Will definitely be returning if I need auto-electrical work again.",
  },
  {
    name: "Sorentino Polo Shirts",
    service: "Stereo Install",
    quote: "Had my daughter's stereo installed — Zac was awesome. Highly recommend.",
  },
  {
    name: "Nicholas McKinnon",
    service: "Headlights",
    quote: "Zac helped me with the headlights on my car in record time. Strongly recommend.",
  },
  {
    name: "Blaise Cormack",
    service: "Diagnostics",
    quote: "Fixed my O2 sensor perfectly. Couldn't have asked for better service.",
  },
  {
    name: "Ivette Rieksts",
    service: "Auto Electrical",
    quote:
      "Excellent experience. Fixed my brake light quickly and had parts ordered immediately. Very friendly and efficient.",
  },
  {
    name: "Archie",
    service: "Auto Electrical",
    quote:
      "Super nice bloke, I called and came in on the same day and he stayed and did my car after closing hours. Very reasonably priced and super knowledgeable on everything I asked him about.",
  },
  {
    name: "Cj Richens",
    service: "12V / Wiring",
    quote: "Very knowledgeable with 12v and some of the neatest wiring I have seen. Will definitely be recommending.",
  },
  {
    name: "Ian Richens",
    service: "Wiring",
    quote: "Meticulous attention to detail. Best wiring work I've seen. Highly recommend.",
  },
  {
    name: "Blake Trotter",
    service: "12V / Wiring",
    quote: "Great advice and options for all budgets. Highly recommend for 12V setups.",
  },
  {
    name: "Ben Munro",
    service: "Auto Electrical",
    quote: "Excellent customer service and quality work. Highly recommend.",
  },
  {
    name: "Brandon Munro",
    service: "Diagnostics",
    quote:
      "Incredible knowledge. Diagnosed the issue on the spot and explained everything clearly.",
  },
  {
    name: "Ashleighann7",
    service: "Emergency Repair",
    quote:
      "Zac saved the day today. He made room for an emergency repair and got us back on the road. Amazing service and gave us insight for how to repair if it happens again.",
  },
  {
    name: "Sue Mangan",
    service: "Emergency Repair",
    quote:
      "Came out after hours, diagnosed and fixed the issue immediately. Extremely professional.",
  },
  {
    name: "John Walker",
    service: "Emergency Repair",
    quote: "Very professional and dropped everything to help us out. Highly recommend.",
  },
  {
    name: "Luke Michael",
    service: "Diagnostics",
    quote:
      "Called last minute and Zac got me in and out. Explained exactly what was wrong. Highly recommended.",
  },
  {
    name: "Ben Reed",
    service: "Auto Electrical",
    quote: "Excellent quality at a very reasonable price.",
  },
  {
    name: "Shaunn Chandler",
    service: "Auto Electrical",
    quote: "Excellent service, tidy work at a fair price. Definitely would recommend Zac for any auto electrical work.",
  },
  {
    name: "Ken Peisley",
    service: "Auto Electrical",
    quote: "Great service, everything explained in a way I could understand and reasonably priced. Will definitely be back.",
  },
  {
    name: "Sam West",
    service: "Diagnostics",
    quote:
      "Fast, reliable, and reasonably priced. Diagnosed and fixed my car quickly and professionally.",
  },
  {
    name: "Tom Blakeney",
    service: "European Vehicle",
    quote: "Awesome job fixing my European car. Fast and professional service.",
  },
  {
    name: "Christine Spink",
    service: "Diagnostics",
    quote:
      "Tracked down faults quickly and fixed everything. Professional, prompt, and great to deal with.",
  },
  {
    name: "Quinn Joyce",
    service: "Diagnostics",
    quote:
      "Went above and beyond diagnosing multiple issues and sourcing hard-to-find parts. Highly recommended.",
  },
  {
    name: "John Fisher",
    service: "Auto Electrical",
    quote:
      "Honest, thorough and professional. Explained everything clearly and showed genuine care for his work.",
  },
  {
    name: "Nina Richter",
    service: "Auto Electrical",
    quote: "Amazing service. Professional and knowledgeable. Highly recommend.",
  },
  {
    name: "Jacques Markram",
    service: "Workmanship",
    quote: "Great workmanship and went above and beyond. Highly recommend.",
  },
  {
    name: "Michael Olsson",
    service: "Repeat Customer",
    quote: "Used Powerz multiple times. Always neat, high-quality work at fair pricing.",
  },
  {
    name: "Shelby Mills",
    service: "Auto Electrical",
    quote: "Efficient, reliable, and honest. High standard of work and very quick turnaround.",
  },
  {
    name: "Tim McQuoid",
    service: "Diagnostics",
    quote: "Diagnosed an ongoing issue in minutes. Great to deal with.",
  },
  {
    name: "Caitlin Webster",
    service: "Auto Electrical",
    quote: "Super helpful, great value, and explained everything clearly.",
  },
  {
    name: "Joel Morish",
    service: "Auto Electrical",
    quote: "Professional, efficient, and hassle-free. Highly recommend.",
  },
  {
    name: "Ashton Anderson",
    service: "Diagnostics",
    quote: "Found an issue multiple shops couldn't. Extremely knowledgeable.",
  },
  {
    name: "Dale Mangan",
    service: "Diagnostics",
    quote: "Fixed an issue others couldn't. Explained everything clearly and arrived on time.",
  },
  {
    name: "Trent Harmsworth",
    service: "Workmanship",
    quote: "Extremely professional with high-quality work at a great price.",
  },
  {
    name: "Noosa Melting Moments",
    service: "Diagnostics",
    quote: "Persistent and reliable — found and fixed a problem others couldn't.",
  },
  {
    name: "Sand Between Your Toes",
    service: "Auto Electrical",
    quote: "Excellent work and priced right. Reliable and high quality.",
  },
  {
    name: "Chelsea Carpenter",
    service: "Diagnostics",
    quote: "Quick diagnosis and fair pricing. Highly recommend.",
  },
  {
    name: "Sue Maclennan",
    service: "Auto Electrical",
    quote:
      "Turned up on time, explained everything, and fixed the issue. Friendly and fairly priced. Highly recommend.",
  },
  {
    name: "Rheese Wallin",
    service: "Auto Electrical",
    quote: "Exceptional experience. Explained everything and provided great value.",
  },
  {
    name: "Hayley Gray",
    service: "Auto Electrical",
    quote: "Top-notch service, quick turnaround, and fair pricing. Highly recommend.",
  },
];

export const FEATURED_REVIEWS = REVIEWS.filter((r) => r.featured);
export const TOTAL_REVIEWS = 95;
export const STAR_AVERAGE = "5.0";

// Quick stats for trust badges (visible text, not fabricated schema)
export const REVIEW_STATS = {
  total: TOTAL_REVIEWS,
  average: STAR_AVERAGE,
  source: "Google",
};
